<div class="flex w-full flex-col">
  <div
    #contentWrapper
    class="flex overflow-hidden mx-auto gap-5 w-full relative text-gray-dark bg-gray-white">
    <ng-content></ng-content>
  </div>
  <div
    class="flex flex-row w-full mx-auto mt-10 justify-center items-center text-lg fill-accent-base z-50">
    <div class="w-16 flex flex-row justify-end pr-4 items-center h-8">
      <div class="hover:fill-secondary-base" (click)="prevSlide()">
        <svg
          class="cursor-pointer"
          [icon]="'left-arrow'"
          iconCollection="button-icons-sprite"
          width="32px"
          height="32px"></svg>
      </div>
      <div class="pl-1.5 pt-0.5">{{ currentSlideNumber }}</div>
    </div>
    <div class="flex flex-row">/</div>
    <div class="w-16 flex flex-row pl-1.5 h-8">
      <div class="pl-1.5 pr-1.5 pt-0.5 h-8">
        {{ carouselSlide.length }}
      </div>
      <div class="hover:fill-secondary-base" (click)="nextSlide()">
        <svg
          class="cursor-pointer"
          [icon]="'right-arrow'"
          iconCollection="button-icons-sprite"
          width="32px"
          height="32px"></svg>
      </div>
    </div>
  </div>
</div>
